import {css, cx} from "@panda/css";

import {HotIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {AdvancedScroll} from "@pg-mono/advanced-scroll-module";

import {IRecommendedOffer} from "../../../../../offer/types/IRecommendedOffer";
import {PropertyListItem} from "../../../../../property/components/PropertyListItem";
import {IRecommendedProperty} from "../../../../../property/types/IRecommendedProperty";

interface IProps {
    recommendations: IRecommendedProperty[] | IRecommendedOffer[] | null;
    disableHeader?: boolean;
    disableScroll?: boolean;
    className?: string;
}
// TODO code to be deleted or used in the future, business does not know whether we ultimately want to abandon multilead
export const LeadModalPriceConversationMultiLeadDetails = (props: IProps) => {
    const {disableHeader, disableScroll, className, recommendations = []} = props;

    return (
        <div className={cx(containerStyles, className)}>
            {!disableHeader && (
                <div className={sectionHeaderStyles}>
                    <div className={iconWrapperStyles}>
                        <HotIcon size="3.2" wrapperSize="3.2" wrapperColor="var(--colors-primary)" />
                    </div>
                    <Text variant="body_copy_2" as="h3">
                        Zapytaj o podobne oferty w najbliższej okolicy.
                    </Text>
                </div>
            )}
            <AdvancedScroll autoHeight contentClassName={multiLeadListStyles} disableScroll={disableScroll}>
                {recommendations?.map((recommendation) => {
                    if (isPropertyRecommendation(recommendation)) {
                        return (
                            <PropertyListItem
                                key={`mrp-${recommendation.id}`}
                                id={recommendation.id}
                                offerType={recommendation.offer.type}
                                offerName={recommendation.offer.name}
                                offerVendorName={recommendation.offer.vendor.name}
                                offerAddress={recommendation.offer.address}
                                offerPrivacyPolicyUrl={recommendation.offer.configuration.privacy_policy_url}
                                offerPrivacyDataProcessorName={recommendation.offer.configuration.personal_data_processor_name}
                                offerPersonalDataProcessorUrl={recommendation.offer.configuration.personal_data_processor_url}
                                rooms={recommendation.rooms}
                                area={recommendation.area}
                                imageSrc={recommendation.offer.main_image?.m_img_350x230}
                                constructionDateRange={recommendation.offer.construction_date_range}
                                className={multiLeadListItemStyles}
                            />
                        );
                    }

                    // currently we don't handle anything else than property recommendations
                    return null;
                })}
            </AdvancedScroll>
        </div>
    );
};

// guards
const isPropertyRecommendation = (recommendation: IRecommendedProperty | IRecommendedOffer): recommendation is IRecommendedProperty => {
    return "offer" in recommendation && !!recommendation.offer;
};

// Styles
const containerStyles = css({
    display: "flex",
    flexDirection: "column",
    height: "100%"
});

const sectionHeaderStyles = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 1,
    py: 0.5,
    mb: 2,
    flexShrink: 0
});

const iconWrapperStyles = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3.2rem",
    height: "3.2rem",
    flexShrink: 0
});

const multiLeadListStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    md: {
        flex: "1 1 auto",
        gap: 2,
        pr: 1
    }
});

const multiLeadListItemStyles = css({
    backgroundColor: "#fff"
});
import {css, cx} from "@panda/css";

import {HotIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {AdvancedScroll} from "@pg-mono/advanced-scroll-module";

import {IRecommendedOffer} from "../../../../../offer/types/IRecommendedOffer";
import {PropertyListItem} from "../../../../../property/components/PropertyListItem";
import {IRecommendedProperty} from "../../../../../property/types/IRecommendedProperty";

interface IProps {
    recommendations: IRecommendedProperty[] | IRecommendedOffer[] | null;
    disableHeader?: boolean;
    disableScroll?: boolean;
    className?: string;
}
// TODO code to be deleted or used in the future, business does not know whether we ultimately want to abandon multilead
export const LeadModalPriceConversationMultiLeadDetails = (props: IProps) => {
    const {disableHeader, disableScroll, className, recommendations = []} = props;

    return (
        <div className={cx(containerStyles, className)}>
            {!disableHeader && (
                <div className={sectionHeaderStyles}>
                    <div className={iconWrapperStyles}>
                        <HotIcon size="3.2" wrapperSize="3.2" wrapperColor="var(--colors-primary)" />
                    </div>
                    <Text variant="body_copy_2" as="h3">
                        Zapytaj o podobne oferty w najbliższej okolicy.
                    </Text>
                </div>
            )}
            <AdvancedScroll autoHeight contentClassName={multiLeadListStyles} disableScroll={disableScroll}>
                {recommendations?.map((recommendation) => {
                    if (isPropertyRecommendation(recommendation)) {
                        return (
                            <PropertyListItem
                                key={`mrp-${recommendation.id}`}
                                id={recommendation.id}
                                offerType={recommendation.offer.type}
                                offerName={recommendation.offer.name}
                                offerVendorName={recommendation.offer.vendor.name}
                                offerAddress={recommendation.offer.address}
                                offerPrivacyPolicyUrl={recommendation.offer.configuration.privacy_policy_url}
                                offerPrivacyDataProcessorName={recommendation.offer.configuration.personal_data_processor_name}
                                offerPersonalDataProcessorUrl={recommendation.offer.configuration.personal_data_processor_url}
                                rooms={recommendation.rooms}
                                area={recommendation.area}
                                imageSrc={recommendation.offer.main_image?.m_img_350x230}
                                constructionDateRange={recommendation.offer.construction_date_range}
                                className={multiLeadListItemStyles}
                            />
                        );
                    }

                    // currently we don't handle anything else than property recommendations
                    return null;
                })}
            </AdvancedScroll>
        </div>
    );
};

// guards
const isPropertyRecommendation = (recommendation: IRecommendedProperty | IRecommendedOffer): recommendation is IRecommendedProperty => {
    return "offer" in recommendation && !!recommendation.offer;
};

// Styles
const containerStyles = css({
    display: "flex",
    flexDirection: "column",
    height: "100%"
});

const sectionHeaderStyles = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 1,
    py: 0.5,
    mb: 2,
    flexShrink: 0
});

const iconWrapperStyles = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3.2rem",
    height: "3.2rem",
    flexShrink: 0
});

const multiLeadListStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    md: {
        flex: "1 1 auto",
        gap: 2,
        pr: 1
    }
});

const multiLeadListItemStyles = css({
    backgroundColor: "#fff"
});
